export const modelList = [
  "gemini-1.5-pro",
  "gemini-1.5-flash",
  "gemini-1.0-pro"
];
